import { useEffect, useState } from 'react';
import { NavLink, withRouter } from 'react-router-dom';

import BadgeStatus from '../../../../../components/Common/BadgeStatus';
import AlertService from '../../../../../components/SweetAlert';
import ToastUtil from '../../../../../components/ToastNotification/ToastUtil';
import { config } from '../../../../../config';
import { DELETE, GET, newFetch, PUT } from '../../../../../helpers/fetch';
import { formatAmount } from '../../../../../helpers/general';
import LayoutContext from '../../../../../store/Layout/contexts';

const { SERVER_URL } = config;

const EditClaim = ({
  history,
  match: {
    params: { claim_id, num },
  },
}) => {
  const accessType = localStorage.getItem('type');
  const [selectedAssociate, setSelectedAssociate] = useState(0);
  const [type, setType] = useState(0);
  const [amount, setAmount] = useState('');
  const [remarks, setRemarks] = useState('');
  const [statusOptions, setStatusOptions] = useState([]);
  const [client, setClient] = useState('');
  const [status, setStatus] = useState(0);
  const [dateOfReceipt, setDateOfReceipt] = useState();
  const [receiptNo, setReceiptNo] = useState();
  const [reimbursement, setReimbursement] = useState();
  const [claim, setClaim] = useState('');
  const [adminRemarks, setAdminRemarks] = useState('');
  const [file, setFile] = useState([]);
  const [file2, setFile2] = useState([]);
  const [file3, setFile3] = useState([]);
  const [origAdminRemarks, setOrigAdminRemarks] = useState([]);
  const [origStatus, setOrigStatus] = useState([]);
  const [filePath, setFilePath] = useState([]);
  const [filePath2, setFilePath2] = useState([]);
  const [filePath3, setFilePath3] = useState([]);
  const [siteId, setSiteId] = useState('');

  const fetchStatusOptions = async () => {
    let api_path = `/fields/claim_status`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setStatusOptions(response.data);
    }
  };

  const fetchClaim = async () => {
    let api_path = `/claims/${claim_id}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let responseData = response.data;
      setClaim(responseData);
      setStatus(responseData.status);
      setSelectedAssociate(
        responseData.associate.first_name +
          ' ' +
          responseData.associate.last_name,
      );
      setDateOfReceipt(responseData.date_of_receipt);
      setReceiptNo(responseData.receipt_no);
      setReimbursement(responseData.deduct_amount);
      setType(responseData.claim_types.name);
      setAmount(responseData.amount);
      setRemarks(responseData.remarks);
      setAdminRemarks(responseData.mp_remarks);
      setFile(responseData.orig_file);
      setFile2(responseData.orig_file_2);
      setFile3(responseData.orig_file_3);
      setFilePath(responseData.new_file);
      setFilePath2(responseData.new_file_2);
      setFilePath3(responseData.new_file_3);
      setClient(responseData.associate.sites[0].client.name);
      setOrigAdminRemarks(responseData.mp_remarks);
      setOrigStatus(responseData.status);
      setSiteId(responseData.associate.sites[0].id);
    }
  };

  const validateForm = () => {
    if (parseInt(status) === 0 || !status) {
      ToastUtil.error('Select Status');
      return false;
    }

    return true;
  };

  const HandleSubmitUpdate = async (e) => {
    e.preventDefault();

    if (
      validateForm() &&
      (await AlertService.confirm(
        '',
        `Are you sure you want to update this Claim?`,
      ))
    ) {
      let api_path = `/claims/${claim_id}`;
      let response = await newFetch(PUT, api_path, {
        status,
        mp_remarks: adminRemarks,
        type: accessType,
        approver_level: num,
        site_id: siteId,
      });

      ToastUtil.success(response.message);

      if (response.success) {
        history.push(`/claims/approval`);
      }
    }
  };

  const handleDiscard = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to discard all changes?',
      )
    ) {
      setStatus(0);
      setAdminRemarks(origAdminRemarks || '');
    }
  };

  const handleDeleteClaim = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to delete this Claim?',
      )
    ) {
      let api_path = `/claims/${claim_id}`;
      let response = await newFetch(DELETE, api_path);

      ToastUtil.success(response.message);

      response.success && history.push(`/claims`);
    }
  };

  useEffect(() => {
    fetchClaim();
    fetchStatusOptions();
  }, []);

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => {
        return (
          <div style={{ paddingTop: '3rem' }}>
            <div
              className="d-flex flex-column"
              style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
            >
              <NavLink
                to={`/claims/approval`}
                className="text-decoration-none"
                style={{ color: 'inherit' }}
              >
                <div style={{ color: '#A6478E' }}>
                  <i className="fas fa-chevron-left pe-2"></i>Back to Approval
                  Listing
                </div>
              </NavLink>
              <div className="pt-4">
                <h5>Manage Claim | {claim_id}</h5>
              </div>
            </div>
            <form className="form" onSubmit={(e) => HandleSubmitUpdate(e)}>
              <div
                style={{
                  marginTop: '1rem',
                  paddingLeft: '3rem',
                  paddingRight: '3rem',
                  paddingBottom: '6rem',
                }}
              >
                <div className="d-flex border rounded adjust-shadow">
                  <div
                    className="flex-grow-1 bg-white col-md-7"
                    style={{ padding: '2.25rem' }}
                  >
                    <div className="pb-3 col-md-8">
                      <strong>Current Status</strong>
                      <br />
                      <BadgeStatus status={status} />
                    </div>

                    <div className="row pb-3 col-md-8">
                      <strong>Change Status</strong>
                      <select
                        name="status"
                        className="form-select mt-3 adjust-fs"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        <option value={0}>Select Status</option>
                        {statusOptions &&
                          statusOptions
                            .filter((status) => status.value != 'Pending')
                            .map((status, index) => (
                              <option
                                key={`${status.id}_${index}`}
                                value={status.value}
                              >
                                {status.label}
                              </option>
                            ))}
                      </select>
                    </div>
                    <div
                      className="row col-md-12"
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <strong>Date of Receipt</strong>
                      <p className="adjust-fs text-muted">{dateOfReceipt}</p>
                    </div>
                    <div
                      className="row col-md-12"
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <strong>Receipt No.</strong>
                      <p className="adjust-fs text-muted">{receiptNo}</p>
                    </div>
                    <div
                      className="row col-md-12"
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <strong>Client</strong>
                      <p className="adjust-fs text-muted">{client}</p>
                    </div>
                    <div
                      className="row col-md-12"
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <strong>Employee Name</strong>
                      <p className="adjust-fs text-muted">
                        {selectedAssociate}
                      </p>
                    </div>
                    <div
                      className="row col-md-12"
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <strong>Type</strong>
                      <p className="adjust-fs text-muted">{type}</p>
                    </div>
                    <div
                      className="row col-md-12"
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <strong>Amount</strong>
                      <p className="adjust-fs text-muted">
                        {' '}
                        {formatAmount(amount)}
                      </p>
                    </div>
                    <div
                      className="row col-md-12"
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <strong>Reimbursement</strong>
                      <p className="adjust-fs text-muted">
                        {' '}
                        {formatAmount(reimbursement)}
                      </p>
                    </div>

                    <div
                      className="row col-md-12"
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <strong>Receipt/Invoice</strong>
                      <p className="adjust-fs text-muted">
                        {file}&nbsp;&nbsp;
                        <a
                          href={`${SERVER_URL}/storage/claims/${filePath}`}
                          target="_blank"
                        >
                          <i className="fa fa-file-text font-size-18"></i>
                        </a>
                      </p>
                    </div>

                    {file2 && (
                      <div
                        className="row col-md-12"
                        style={{ display: 'flex', flexDirection: 'column' }}
                      >
                        <strong>Photo of you wearing the safety shoes</strong>
                        <p className="adjust-fs text-muted">
                          {file2}&nbsp;&nbsp;
                          <a
                            href={`${SERVER_URL}/storage/claims/${filePath2}`}
                            target="_blank"
                          >
                            <i className="fa fa-file-text font-size-18"></i>
                          </a>
                        </p>
                      </div>
                    )}

                    {file3 && (
                      <div
                        className="row col-md-12"
                        style={{ display: 'flex', flexDirection: 'column' }}
                      >
                        <strong>Certification of safety shoes</strong>
                        <p className="adjust-fs text-muted">
                          {file3}&nbsp;&nbsp;
                          <a
                            href={`${SERVER_URL}/storage/claims/${filePath3}`}
                            target="_blank"
                          >
                            <i className="fa fa-file-text font-size-18"></i>
                          </a>
                        </p>
                      </div>
                    )}

                    <div
                      className="row col-md-12"
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <strong>Employee Remarks</strong>
                      <p className="adjust-fs text-muted">{remarks}</p>
                    </div>
                    <div className="row pb-3 col-md-12">
                      <strong>Approver/Admin Remarks</strong>
                      <textarea
                        rows="10"
                        className="form-control mt-3 adjust-fs"
                        style={{ resize: 'none' }}
                        placeholder="Remarks"
                        value={adminRemarks || ''}
                        onChange={({ target: { value } }) =>
                          setAdminRemarks(value)
                        }
                      />
                    </div>
                  </div>
                  <div
                    className="flex-grow-1 bg-white col-md-5"
                    style={{ paddingTop: '2.25rem' }}
                  ></div>
                </div>
              </div>

              <div
                style={{
                  position: 'fixed',
                  bottom: 0,
                  width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                  height: '4.5rem',
                  paddingRight: '3rem',
                }}
                className="border-top bg-white d-flex align-items-center justify-content-end"
              >
                <button
                  type="button"
                  className="btn btn-outline-brand adjust-fs adjust-shadow"
                  style={{ width: '12rem' }}
                  onClick={handleDiscard}
                >
                  Discard
                </button>
                <button
                  type="submit"
                  className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                  style={{ width: '12rem' }}
                >
                  Save changes
                </button>
              </div>
            </form>
          </div>
        );
      }}
    </LayoutContext.Consumer>
  );
};

export default withRouter(EditClaim);
